import DirectorService from 'services/DirectorService';
import UserService from 'services/UserService';

const userService = UserService.getInstance();

const directorService = DirectorService.getInstance();


function useDirector() {
  const addDirector = async (centerId: number, body: any) => directorService.postDirector(centerId, body);

  const updateDirector = async (centerId: number, directorId: number, body: any) => directorService.putDirector(centerId, directorId, body);

  const moveDirectors = ({
    directors = [],
    centers = [],
    centerId,
  }: {
    directors: number[];
    centers: number[];
    centerId: number;
  }) =>
    userService.moveDirectors(
      {
        director_ids: directors,
        center_ids: centers,
      },
      centerId,
    );

  return {
    addDirector,
    updateDirector,
    moveDirectors,
  };
}

export default useDirector;
